import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import layout from "antd/lib/layout"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { DateSelect } from "../../../compnents/form/DateSelect"
import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import { stringTrim } from "../../../utils/StringUtils"
import FileUpload from "../../../compnents/file/FileUpload"
import Upload, { RcFile } from "antd/lib/upload"
import { UploadFile } from "antd/lib/upload/interface"
import styles from "../filing.module.css"
import axios from "axios"
import {
  selectCredentials,
  selectTenantName,
} from "../../../app/applicationSlice"
import { selectTenant } from "../../user/setting/settingSlice"
import moment from "moment"
import { DateTimeFormatSimpleOnly } from "../../../models/datetime"
import { AXIOS_IP, beforeUploadFile, generateTempId } from "../fileUploadService"
import { PreviewImgOrPdf } from "../Preview"
import { EditableList } from "../../../compnents/list/EditableList"
import { KJYWCatalogColumns, KJYWCatalogTemporaryColumns } from "../columns"
import { validateArrayDataFirstError, validateRequiredFields } from "./validate"

export const KJYWTemporaryModal = (props: {
  visible: boolean
  token: string
  againId?: string
  KJYWData?: { isAdjustment: number, sameNameProcurementCount: string }
  memo?: string
  isFiling?: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const credentials: any = useSelector(selectCredentials)

  const [form] = Form.useForm()

  const [submitVisible, setSubmitVisible] = useState(false)

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [pageLoading, setPageLoading] = useState(false)

  const [data, setData] = useState<any[]>([])

  const requiredList = [
    { name: "药品通用名", key: "drugName", required: true },
    { name: "剂型", key: "dosageForm", required: true },
    { name: "规格", key: "specification", required: true },
    { name: "单位", key: "unit", required: true },
    { name: "数量", key: "count", required: true },
    { name: "采购次数", key: "procurementCount", required: true },
  ]

  useEffect(() => {
    if (props.visible) {
      if(props.againId) {
        setPageLoading(true)
        axios({
          url: `${AXIOS_IP}/procurement/list`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": props.token,
          },
          withCredentials: false,
          method: "POST",
          data: { [props?.isFiling ? 'filingAntibacterialDrugRecordId' : 'filingReviewAntibacterialDrugRecordId']: props.againId, pageNo: 1, pageSize: 100 },
        }).then((res) => {
          const data = res.data.data
          setData(data?.records?.concat([{ id: generateTempId() }]) || [{ id: generateTempId() }])
        }).catch((err) => { console.error(err) }).finally(() => {
          setPageLoading(false)
        })
      } else if (!data.length) {
        setData([{ id: generateTempId() }])
      }
      if (props.KJYWData) {
        form.setFieldsValue({
          isAdjustment: props.KJYWData?.isAdjustment,
          sameNameProcurementCount: props.KJYWData?.sameNameProcurementCount
        })
      }
    } else {
      setData([])
      form.resetFields()
    }
  }, [props.visible])

  return (
    <>
      <Modal
        title="抗菌药物临时采购备案"
        width={1300}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={() => {
         form.submit()
        }}
        okText="提交"
        centered
        maskClosable={false}
      >
        <div>
          <Row style={{ color: "#FF1B1B", marginBottom: "10px" }}>
            备注：经医疗机构药事管理与药物治疗学委员会抗菌药物管理工作组讨论通过后报核发《医疗机构执业许可证》的卫生健康行政部门备案。
          </Row>
          <Form
            form={form}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              const msg = validateArrayDataFirstError(data?.slice(0, -1), requiredList)
              if(data?.length <= 1) {
                return
              }
              if(msg.isValid) {
                setSubmitVisible(true)
              } else {
                notification.warning({
                  message: msg.error.message,
                })
              }
            }}
          >
            <Row>
              <Col span={12}>
                <Form.Item
                  labelCol={{ span: 9 }}
                  wrapperCol={{ span: 10 }}
                  name="sameNameProcurementCount"
                  label="同一通用名抗菌药物品种采购次数"
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 14 }}
                  name="isAdjustment"
                  label="是否重新调整本机构抗菌药物采购目录"
                  rules={[{ required: true }]}
                >
                  <Radio.Group>
                    <Radio value={1}>是</Radio>
                    <Radio value={0}>否</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <EditableList
            style={{ marginTop: "0px", minHeight: "300px" }}
            scroll={{ x: "30rem" }}
            dataSource={data}
            loading={pageLoading}
            pagination={false}
            rowKey={(m: any) => m.id}
            columns={KJYWCatalogTemporaryColumns(
              AXIOS_IP,
              props.token,
              props.visible,
              (text, t) => {
                if (text == "edit") {
                  const result = validateRequiredFields(t, requiredList)
                  const flag =
                    data.findIndex((d) => d.id === t.id) === data.length - 1
                  const newData = data.map((item: any) => {
                    if (item.id == t.id) {
                      return t
                    } else {
                      return item
                    }
                  })

                  setData(
                    result
                      ? newData
                      : flag //判断是否为最新一行，是的就添加一行
                      ? newData.concat([{ id: generateTempId() }])
                      : newData 
                  )
                } else if (text === "add") {
                  // const result = validateRequiredFields(t, requiredList)
                  // if (!result) {
                  //   setData([...data, { id: generateTempId() }])
                  // }
                } else if (text == "remove") {
                  const flag = data.findIndex((d) => d.id === t.id) === data.length - 1
                  if (flag) {
                    setData(data.map((item: any) => {
                      if (item.id == t.id) {
                        return { id: generateTempId() }
                      } else {
                        return item
                      }
                    }))
                  } else {
                    setData(data.filter((item: any) => item.id != t.id))
                  }
                }
              }
            )}
            sticky
          />
        </div>
      </Modal>

      <Modal
        title="提交申请"
        width={450}
        visible={submitVisible}
        onCancel={() => setSubmitVisible(false)}
        confirmLoading={confirmLoading}
        onOk={() => {
          setConfirmLoading(true)
          const params = {
            applicantUserId: credentials.userId,
            applicantUserName: credentials.userName,
            childFilingType: 1,
            id: !props.isFiling ? props.againId : undefined,
            filingAntibacterialDrugRecordId: props.isFiling ? props.againId : undefined,
            memo: props.memo,
            ...form.getFieldsValue(),
            procurementDTOList: data?.slice(0, -1)?.map((d: any) => {
              return {
                ...d,
                filingAntibacterialDrugRecordId: undefined,
                id: null
              }
            })
          }
          axios({
            url: `${AXIOS_IP}/filingReviewAntibacterial/saveOrUpdate`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": props.token,
            },
            withCredentials: false,
            method: "POST",
            data: params,
          })
            .then((res) => {
              if (res.data?.data || res.data?.success) {
                setSubmitVisible(false)
                notification.success({
                  message: "操作成功",
                })
                props.onOk()
              } else {
                notification.error({
                  message: res.data?.msg || "操作失败，请稍后重试",
                })
              }
            })
            .catch(() => {
              notification.error({
                message: "请求异常，请稍后重试",
              })
            })
            .finally(() => {
              setConfirmLoading(false)
            })
        }}
        okText="确认提交"
        centered
        maskClosable={false}
      >
        <Row style={{ height: 50 }}>
          提交后请耐心等待工作人员审核
        </Row>
      </Modal>
    </>
  )
}
